module.exports = __webpack_public_path__ + "039b60937b98aa14c7b359fed80b57eb.pdf";